"use client";

import { useIsTouchDevice } from "@/hooks/use-is-touch-device";
import { useMediaQuery } from "@/hooks/use-media-query";
import {
  type DeviceClass,
  PHONE_MEDIA_QUERY,
  resolveDeviceClass,
  TABLET_WIDTH_MEDIA_QUERY,
} from "@/lib/device-class";

/**
 * Which layout this device should be served, kept in step with the `mobile:`
 * and `tablet:` Tailwind variants. See {@link resolveDeviceClass}.
 *
 * Distinct from `useIsMobile`, which stays a pure phone-width check because it
 * also gates the shared-device inactivity logout.
 */
export function useDeviceClass(): DeviceClass {
  const isPhoneWidth = useMediaQuery(PHONE_MEDIA_QUERY);
  const isTabletWidth = useMediaQuery(TABLET_WIDTH_MEDIA_QUERY);
  const hasCoarsePointer = useIsTouchDevice();

  return resolveDeviceClass({
    isPhoneWidth,
    isTabletWidth,
    hasCoarsePointer,
  });
}
